(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('AccountInfoController', AccountInfoController);

    function AccountInfoController($rootScope, $scope, $stateParams, $state, $mdDialog, $mdMedia, $timeout, $mdSidenav, $mdBottomSheet, $filter, events, account, utils, customfields, network, sfWalkthrough, sfFindLeadsDialog, email, flagsService, helperFunctionsService, opportunityService, model, $translate, $sce) {

        $scope.id = $stateParams.id;
        $scope.type = $state.current.data.type;
        $scope.editable = true;
        $scope.showDetails = sfWalkthrough.isShowing() || !!store.get('show_account_details');
        $scope.showDisabledUsers = !!store.get('show_disabled_users');
        $scope.hasMoreSuggestions = false;
        $scope.hasMoreNetwork = false;
        $scope.hasDoneOpportunities = false;
        $scope.me = model.me;
        $scope.insufficientPermissionsMessage = $translate.instant('You don\'t have permission to edit this account. Ask an admin.') || 'You don\'t have permission to edit this account. Ask an admin.';
        $scope.descriptionExtendable = false;
        $scope.descriptionExtended = false;
        $scope.isRelationshipVisualizationEnabled = (flagsService.get('relationshipVisualization') === true);
        $scope.openMenuAriaLabel = $translate.instant('Open menu');
        $scope.acceptSuggestionAriaLabel = $translate.instant('accept suggestion');
        $scope.rejectSuggestionAriaLabel = $translate.instant('reject suggestion');
        $scope.createSuggestionAriaLabel = $translate.instant('create suggestion');
        $scope.callContactAriaLabel = $translate.instant('call contact');
        $scope.emailAriaLabel = $translate.instant('email');

        // These are contacts suggested by the LinkedIn sidebar or existing contacts related to a LinkedIn company
        let contacts = $stateParams.contacts ? angular.fromJson($stateParams.contacts) : null;

        // Must be the same as default_Limit on account entity in server
        const networkLimit = 21;

        // Must be the same as suggestionLimit on account entity in server
        const suggestionLimit = 21;

        const firstViewed = $stateParams.firstViewed;

        let suggestionsWalkthrough = null;

        // Check if the description is extendable when the description's element is loaded and its height is known
        $scope.$on('$viewContentLoaded', function () {

            $timeout(() => {

                isDescriptionExtendable();
            }, 0);
        });

        $scope.$on('$destroy', function () {

            if (suggestionsWalkthrough) {
                try {
                    suggestionsWalkthrough.cancel();
                }
                catch {
                    // Do nothing
                }

                suggestionsWalkthrough = null;
            }
        });

        if ($scope.account) {
            prepareSuggestions();
            checkIfCanFindLeads();
            showInfo();
        }
        else {
            $scope.$on(events.account.loaded, function (event, loadedAccount) {

                $scope.account = loadedAccount;

                if ($scope.showDoneOpportunities) {
                    $scope.opportunities = $scope.account.opportunities;
                }
                else {
                    $scope.opportunities = $scope.account.opportunities.filter(function (opp) {

                        return !opp.done;
                    });
                }

                $scope.hasDoneOpportunities = $scope.account.opportunities.some(function (opp) {

                    return opp.done;
                });

                prepareSuggestions();
                checkIfCanFindLeads();

                if ($scope.account.custom && Object.keys($scope.account.custom).length > 0) {
                    loadCustomFields();
                }

                checkIfCustomFieldsAreEmpty();

                return network.get({ account: $scope.account_id }).then(prepareNetwork, angular.noop, prepareNetwork);
            });
        }

        if ($state.current.name === 'accounts.account.info' && $rootScope.history[$rootScope.history.length - 1].fromState.name.startsWith('accounts.')) {
            $rootScope.history.pop();
        }

        $scope.$on(events.refreshData, function () {

            return $scope.get();
        });

        $scope.$on(events.account.updated, function () {

            return $scope.get();
        });

        $scope.edit = function () {

            return $state.go('editAccount', angular.merge({}, $stateParams, { id: $scope.account.id }));
        };

        $scope.close = function () {

            return $mdSidenav('right').close();
        };

        $scope.accountTeamIncludesDisabledUsers = function () {

            return !!$scope.account?.users?.find((u) => u.disabled);
        };

        $scope.accountTeamOnlyIncludesDisabledUsers = function () {

            return $scope.account?.users?.every((u) => u.disabled);
        };

        $scope.acceptSuggestion = function (contact, $event) {

            $event.stopPropagation();

            if (sfWalkthrough.isShowing()) {
                sfWalkthrough.acceptDummyContactSuggestion(contact.name);
                return;
            }

            contact._dirty = true;

            return account.acceptSuggestion($scope.id, contact).then(function () {

                if ($scope.account.customers.length === 0 && $scope.account.opportunities.length === 0) {
                    // Set part_of to true so calls for which you need to be part of account also get called
                    $scope.account.part_of = true;

                    return $mdDialog.show({
                        clickOutsideToClose: true,
                        controller: 'OpportunityDialogController',
                        templateUrl: 'partials/opportunitydialog.html',
                        locals: {
                            accountId: $scope.id
                        },
                        onComplete: function (scope, element) {

                            return element['0'].querySelectorAll('INPUT')[0].focus();
                        }
                    }).finally(function () {

                        return $rootScope.$broadcast(events.account.updated);
                    });
                }

                return $rootScope.$broadcast(events.account.updated);
            });
        };

        $scope.acceptAllSuggestions = function () {

            if ($scope.hasMoreSuggestions) {
                const confirm = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant('Are you sure you want to add 20+ contacts to this account?<br>This may slow down the account timeline significantly.') || 'Are you sure you want to add 20+ contacts to this account?<br>This may slow down the account timeline significantly.')
                    .ok($translate.instant('Yes') || 'Yes')
                    .cancel($translate.instant('No') || 'No');

                return $mdDialog.show(confirm).then(function () {

                    return account.acceptAllSuggestions($scope.id).then(function () {

                        return $rootScope.$broadcast(events.account.updated);
                    });
                });
            }

            return account.acceptAllSuggestions($scope.id).then(function () {

                return $rootScope.$broadcast(events.account.updated);
            });
        };

        $scope.rejectSuggestion = function (contact, $event) {

            $event.stopPropagation();

            if (sfWalkthrough.isShowing()) {
                return $mdDialog.show({
                    controller: 'CantDoDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app-ajs/components/cantDoDialog/cantDoDialog.html',
                    bindToController: true,
                    clickOutsideToClose: true,
                    locals: {
                        title: ($translate.instant('That\'s not the checkmark <span class="sf-emoji">😉</span>'))
                    }
                });
            }

            return account.rejectSuggestion($scope.id, contact).then(function () {

                account.getSuggestions($scope.id, null, null, suggestionLimit + 1).then(function (response) {

                    $scope.account.suggestions = response.data;

                    return prepareSuggestions();
                });

                account.getContacts($scope.id, { includeArchived: true }).then(function (response) {

                    $scope.account.customers = response.data;
                });
            });
        };

        $scope.createSuggestion = (personObject, $event) => {

            $event.stopPropagation();

            if (sfWalkthrough.isShowing()) {
                return $mdDialog.show({
                    controller: 'CantDoDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app-ajs/components/cantDoDialog/cantDoDialog.html',
                    bindToController: true,
                    clickOutsideToClose: false
                });
            }

            const cleanedPersonObject = { ...personObject };
            delete cleanedPersonObject.creatable;
            delete cleanedPersonObject.role;

            return $state.go('createContact', {
                personObject: cleanedPersonObject,
                account: $scope.account,
                isLinkedInSuggestion: true,
                from: 'accounts.account.info'
            });
        };

        $scope.createOpportunity = function (accountId) {

            sfWalkthrough.advance();

            return $state.go('opportunity', { id: 'new', account: accountId });
        };

        $scope.toggleDoneOpportunities = function () {

            $scope.showDoneOpportunities = !$scope.showDoneOpportunities;

            if ($scope.showDoneOpportunities) {
                $scope.opportunities = $scope.account.opportunities;
            }
            else {
                $scope.opportunities = $scope.account.opportunities.filter(function (opp) {

                    return !opp.done;
                });
            }
        };

        $scope.setDone = function (opportunity) {


            opportunity.done = !opportunity.done;

            return opportunityService.update(opportunity).then(function () {

                if (opportunity.done) {
                    utils.showSuccessToast($translate.instant('Marked as done! You can still search or filter to find it back.') || 'Marked as done! You can still search or filter to find it back.');
                }

                $scope.hasDoneOpportunities = $scope.account.opportunities.some(function (opp) {

                    return opp.done;
                });

                if ($scope.showDoneOpportunities) {
                    $scope.opportunities = $scope.account.opportunities;
                }
                else {
                    $scope.opportunities = $scope.account.opportunities.filter(function (opp) {

                        return !opp.done;
                    });
                }

            }).catch(function () {

                return $scope.get();
            });
        };

        $scope.goToContact = function (contactId) {

            if (sfWalkthrough.isShowing()) {
                return;
            }

            return $state.go('contact', { id: contactId });
        };

        $scope.mailto = email.mailto;
        $scope.openBottomSheet = function (text) {

            $mdBottomSheet.show({
                templateUrl: 'partials/listbottomsheet.html',
                controller: 'ListBottomSheetController',
                bindToController: true,
                locals: {
                    actions: ['COPY', 'MAILTO'],
                    text
                }
            });
        };

        $scope.openWebsite = helperFunctionsService.openWebsite;
        $scope.callNumber = helperFunctionsService.callNumber;
        $scope.callPerson = function (person, $event) {

            return helperFunctionsService.callPerson(person, $event).then(function () {

                return $rootScope.$broadcast(events.account.updated);
            });
        };

        $scope.hideElement = sfWalkthrough.hideElement;

        $scope.isWalkthroughShowing = sfWalkthrough.isShowing;

        $scope.getWalkthroughCurrentStepId = sfWalkthrough.getCurrentStepId;

        $scope.toggleDescriptionExtended = () => {

            $scope.descriptionExtended = !$scope.descriptionExtended;
        };

        $scope.getHotnessString = () => {

            if (!$scope.account) {
                return;
            }

            if ($scope.account.hotness < 30) {
                return $translate.instant('Room temperature') || 'Room temperature';
            }

            if ($scope.account.hotness < 50) {
                return $translate.instant('Hot') || 'Hot';
            }

            return $translate.instant('On fire') || 'On fire';
        };

        $scope.getHotnessTooltipLabel = () => {

            if (!$scope.account) {
                return;
            }

            if ($scope.account.hotness < 30) {
                return $translate.instant('Recent activity is low') || 'Recent activity is low';
            }

            if ($scope.account.hotness < 50) {
                return $translate.instant('Recent activity is high') || 'Recent activity is high';
            }

            return $translate.instant('Recent activity is very high') || 'Recent activity is very high';
        };

        $scope.getStrongestConnectionString = () => {

            if (!$scope.account || !$scope.account.strongest_connection) {
                return '';
            }

            return $sce.trustAsHtml($translate.instant('Strongest connection with {{name}}', {
                name: $scope.account.strongest_connection.name
            }));
        };

        $scope.getStrongestConnectionTooltipLabel = () => {

            if (!$scope.account) {
                return;
            }

            let tooltipLabel;

            if ($scope.account.connection_strength < 0.2) {
                tooltipLabel = $translate.instant('Strong connection') || 'Strong connection';
            }
            else if ($scope.account.connection_strength < 0.5) {
                tooltipLabel = $translate.instant('Moderate connection') || 'Moderate connection';
            }
            else if ($scope.account.connection_strength < 0.8) {
                tooltipLabel = $translate.instant('Weak connection') || 'Weak connection';
            }
            else {
                tooltipLabel = $translate.instant('One-way connection') || 'One-way connection';
            }

            return $translate.instant('{{connectionType}} with {{name}}', {
                connectionType: tooltipLabel,
                name: $scope.account.strongest_connection.name
            });
        };

        $scope.getEmailRelationshipString = () => {

            if (!$scope.account) {
                return;
            }

            const emailsSent = $scope.account.emails_sent >= 100 ? '99+' : $scope.account.emails_sent;
            const emailsReceived = $scope.account.emails_received >= 100 ? '99+' : $scope.account.emails_received;
            let text = $translate.instant('{{sentCount}} sent, {{receivedCount}} received', {
                sentCount: emailsSent,
                receivedCount: emailsReceived
            });

            if ($scope.account.last_email_date) {
                const lastDate = $filter('formatShortDate')($scope.account.last_email_date, true);
                text += ', ' + $translate.instant('last {{date}}', { date: lastDate });
            }

            return text;
        };

        $scope.getMeetingRelationshipString = () => {

            if (!$scope.account) {
                return;
            }

            const meetingCount = $scope.account.meetings_had;
            const meetingWord = meetingCount === 1 ? $translate.instant('meeting') : $translate.instant('meetings');
            let text = $translate.instant('{{count}} {{meetingWord}}', {
                count: meetingCount,
                meetingWord
            });

            if ($scope.account.last_meeting_date) {
                const lastDate = $filter('formatShortDate')($scope.account.last_meeting_date, true);
                text += ', ' + $translate.instant('last {{date}}', { date: lastDate });
            }

            if ($scope.account.next_meeting_date) {
                const nextDate = $filter('formatShortDate')($scope.account.next_meeting_date, true);
                text += ', ' + $translate.instant('next {{date}}', { date: nextDate });
            }

            return text;
        };

        $scope.getCallRelationshipString = () => {

            if (!$scope.account) {
                return;
            }

            const callCount = $scope.account.calls_had;
            const callWord = callCount === 1 ? $translate.instant('call') : $translate.instant('calls');
            let text = $translate.instant('{{count}} {{callWord}}', {
                count: callCount,
                callWord
            });

            if ($scope.account.last_call_date) {
                const lastDate = $filter('formatShortDate')($scope.account.last_call_date, true);
                text += ', ' + $translate.instant('last {{date}}', { date: lastDate });
            }

            if ($scope.account.next_call_date) {
                const nextDate = $filter('formatShortDate')($scope.account.next_call_date, true);
                text += ', ' + $translate.instant('next {{date}}', { date: nextDate });
            }

            return text;
        };

        function showInfo() {

            if ($scope.showDoneOpportunities) {
                $scope.opportunities = $scope.account.opportunities;
            }
            else {
                $scope.opportunities = $scope.account.opportunities.filter(function (opp) {

                    return !opp.done;
                });
            }

            $scope.hasDoneOpportunities = $scope.account.opportunities.some(function (opp) {

                return opp.done;
            });

            // Do not show on fullscreen since empty state gives info
            if ($scope.account && $scope.account.customers.length === 0 && !$mdMedia('gt-sm')) {
                const key = 'INFO_ACCEPT_SUGGESTION';

                if ((store.get(key) || 0) < 3) {
                    const acceptSuggestionTimer = $timeout(function () {

                        return utils.showInfoToast($translate.instant('Start by accepting a contact suggestion.') || 'Start by accepting a contact suggestion.', $translate.instant('GOT IT') || 'GOT IT').then(function (response) {

                            if (response === ($translate.instant('GOT IT') || 'GOT IT')) {
                                store.set(key, (store.get(key) || 0) + 1);
                            }
                        });
                    }, 1000);

                    // Prevent info to show when not on account info screen anymore
                    $scope.$on('$destroy', function scopeDestroyAcceptSuggestionTimer() {

                        return $timeout.cancel(acceptSuggestionTimer);
                    });
                }
            }
        }

        function prepareSuggestions() {

            if (contacts?.length > 0) {
                const suggestionIds = new Set($scope.account.suggestions.map((suggestion) => suggestion.id));

                // Only add contacts that aren't already in the suggestions or a part of the account
                // Update the contacts variable with the filtered array, so that contacts don't get added again after rejecting
                contacts = contacts.filter((contact) => !suggestionIds.has(contact.id) && !$scope.account.customers.some((customer) => customer.id === contact.id));
                $scope.account.suggestions.unshift(...contacts.map((contact) => {

                    if (contact.positions?.length > 0) {
                        contact.role = contact.positions[0].role;
                    }

                    contact.creatable = contact.id ? false : true;
                    return contact;
                }));
                $scope.suggestionsIncludeLinkedInContacts = $scope.account.suggestions.some((suggestion) => suggestion.creatable);
                $scope.suggestionsOnlyIncludeLinkedInContacts = $scope.account.suggestions.every((suggestion) => suggestion.creatable);
            }

            if ($scope.account.suggestions.length >= suggestionLimit) {
                $scope.hasMoreSuggestions = true;
                $scope.account.suggestions.pop();
            }

            if ($scope.account.suggestions.length > 0) {
                startSuggestionsWalkthrough();
            }

        }

        function startSuggestionsWalkthrough() {

            if (!flagsService.get('showSuggestionsWalkthrough') || sfWalkthrough.isShowing() || !$mdMedia('gt-sm') || !firstViewed) {
                return;
            }

            $timeout(function () {

                if (suggestionsWalkthrough || sfWalkthrough.isShowing()) {
                    return;
                }

                suggestionsWalkthrough = new Shepherd.Tour({
                    defaultStepOptions: {
                        popperOptions: {
                            modifiers: [{ name: 'offset', options: { offset: [0, 10] } }]
                        }
                    }
                });

                suggestionsWalkthrough.addStep({
                    title: $translate.instant('Awesome! Now add contacts to the account too.'),
                    text: $translate.instant('Click on the green checkmarks to accept the relevant contact suggestions.'),
                    attachTo: {
                        element: '.contact-suggestion',
                        on: 'left'
                    },
                    buttons: [{
                        text: $translate.instant('GOT IT!'),
                        action: suggestionsWalkthrough.next
                    }]
                });

                suggestionsWalkthrough.on('complete', function () {

                    return flagsService.set('showSuggestionsWalkthrough', false);
                });

                suggestionsWalkthrough.on('cancel', function () {

                    suggestionsWalkthrough = null;
                });

                suggestionsWalkthrough.start();
            }, 1000);
        }

        function checkIfCanFindLeads() {

            const hasLinkedInSocialProfile = $scope.account.social_profiles.some((socialProfile) => socialProfile.type.includes('linkedin'));
            $scope.canFindLeads = $scope.account.website || hasLinkedInSocialProfile;
        }

        function isDescriptionExtendable() {

            if ($scope.account?.description) {
                const longTextValueLength = $scope.account.description.length;
                let element;
                try {
                    element = angular.element('.sf-account-description')[0];
                }
                catch {
                    // Do nothing and use the fallback
                }

                if (element?.scrollHeight && element?.clientHeight) {
                    // When the scrollHeight is larger than the actual height of the element, it means there is overflowing content, so the description is extendable
                    $scope.descriptionExtendable = element.scrollHeight > element.clientHeight;
                }
                // Fallback is not ideal, since new line characters might surpass 5 lines
                else if (longTextValueLength > 170) {
                    $scope.descriptionExtendable = true;
                }
                else {
                    $scope.descriptionExtendable = false;
                }
            }
        }

        function prepareNetwork(response) {

            $scope.account.network = response.data;

            if ($scope.account.network && $scope.account.network.length >= networkLimit) {
                $scope.hasMoreNetwork = true;
                $scope.account.network.pop();
            }
        }

        function loadCustomFields() {

            return customfields.getAccountFields(false).then(function (response) {

                $scope.customFields = response.data;

                let firstFound = false;

                $scope.customFields.forEach(function (customField) {

                    if (!firstFound && angular.isDefined($scope.account.custom[customField.api_field]) && $scope.account.custom[customField.api_field] !== null && $scope.account.custom[customField.api_field] !== '') {
                        if ((customField.type.type !== 'tags' && customField.type.type !== 'select') || $scope.account.custom[customField.api_field].length === 0) {
                            customField.first = true;
                            firstFound = true;
                        }
                    }

                    if (customField.predefined_customfield) {
                        $scope.account.custom[customField.api_field] = $scope.account[customField.api_field];
                    }

                    if (['tags', 'select'].includes(customField.type.type) && $scope.account.custom[customField.api_field] && angular.isArray($scope.account.custom[customField.api_field])) {
                        $scope.account.custom[customField.api_field].title = $scope.account.custom[customField.api_field].map(function (value) {

                            return value.name;
                        }).join(', ');
                    }

                    // Check if large text fields need the ellipsis class,
                    // if so make sure its collapsed first
                    // We can't use the element attributes here (PersonController)
                    // Since the field doesn't have attributes before Show More is clicked
                    if (customField.type.type === 'large_text') {
                        const longTextValueLength = $scope.account.custom[customField.api_field] ? $scope.account.custom[customField.api_field].length : 0;

                        if (longTextValueLength > 27) {
                            // When the above method fails, this is the fallback check
                            customField.extendable = true;
                        }
                        else {
                            customField.extendable = false;
                        }

                        customField.extended = false;
                    }
                });
            });
        }

        $scope.changeExtended = function (customField) {

            customField.extended = !customField.extended;
        };

        /**
         * @param {Boolean} show
         */
        $scope.setShowDetails = function (show) {

            $scope.showDetails = show;
            store.set('show_account_details', show);
        };

        $scope.showNewFeatureIndicatorLeadSearch = function () {

            return flagsService.get('showLeadSearchWalkthrough');
        };

        $scope.showLeadSearch = function () {

            return flagsService.get('showLeadSearch');
        };

        $scope.findLeads = function () {

            return sfFindLeadsDialog.show($scope.id).then((reload) => {

                if (reload) {
                    return $rootScope.$broadcast(events.account.updated);
                }
            });
        };

        /**
         * @param {Boolean} show
         */
        $scope.setShowDisabledUsers = function (show) {

            $scope.showDisabledUsers = show;
            store.set('show_disabled_users', show);
        };

        function checkIfCustomFieldsAreEmpty() {

            $scope.showCustomFieldsHeader = false;

            if ($scope.account.custom && Object.keys($scope.account.custom).length > 0) {
                for (const key in $scope.account.custom) {
                    if ($scope.account.custom[key] !== null && $scope.account.custom[key] !== '') {
                        if (angular.isArray($scope.account.custom[key]) && $scope.account.custom[key].length === 0) {
                            continue;
                        }

                        $scope.showCustomFieldsHeader = true;

                        break;
                    }
                }
            }
        }
    }
})();
